import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { WarningPopUp, Image } from "hesus-ui-kit";
import QuoteActionPopUp from "../QuoteActionPopUp";
import { handleApiError } from "@utils/errorHandler";
import { downloadFileFromUrl } from "@utils/fileDownload";
import editIcon from "@icons/ic-edit-blue.svg";
import downloadIcon from "@icons/ic-download.svg";
import cancelIcon from "@icons/ic-cancel.svg";
import moreActionIcon from "@icons/ic-more-action.svg";
import { ActionButtons } from "../../QuoteList.styled";
import { quoteMoreAction, quoteMoreActionNoKickoff } from "@utils/constants";

const QuoteAction = (props) => {
  const {
    t,
    siteId,
    quoteId,
    status,
    onRefreshData,
    setIsRefeshSiteData,
    countryId,
    pageType,
    jobsiteNeedKickoff,
  } = props;
  const history = useNavigate();
  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [statusId, setStatusId] = useState("");
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const [displayDropdown, setDisplayDropdown] = useState(false);
  const [isQuotePopupVisible, setQuotePopupVisible] = useState(false);
  const [quoteActions, setQuoteActions] = useState([]);
  const actionDropdownToggle = () => {
    setDisplayDropdown(!displayDropdown);
  };

  const [confirmationBoxTitle, setConfirmationBoxTitle] = useState(
    "QUOTE_CANCEL_CONFIRMATION_BOX_DELETE"
  );
  const [confirmationBoxContent, setConfirmationBoxContent] = useState(
    "QUOTE_CANCEL_CONFIRMATION_BOX_DELETE_CONTENT"
  );

  useEffect(() => {
    setConfirmationBoxTitle("QUOTE_CANCEL_CONFIRMATION_BOX_DELETE");
    setConfirmationBoxContent("QUOTE_CANCEL_CONFIRMATION_BOX_DELETE_CONTENT");
    if (status === 6) {
      setConfirmationBoxTitle("QUOTE_DELETE_CONFIRMATION_BOX_DELETE");
      setConfirmationBoxContent("QUOTE_DELETE_CONFIRMATION_BOX_DELETE_CONTENT");
    }
    if (jobsiteNeedKickoff) setQuoteActions(quoteMoreAction[status]);
    if (!jobsiteNeedKickoff) setQuoteActions(quoteMoreActionNoKickoff[status]);
  }, [status]);

  const generateQuotePdf = (quoteId) => {
    axios
      .get(`/quotes/${quoteId}/generatePDF`)
      .then((response) => {
        downloadFileFromUrl(response?.data?.downloadLink);
      })
      .catch((error) => handleApiError(error));
  };

  const checkQuoteDocument = (quoteId) => {
    axios
      .get(`/documents?quoteId=${quoteId}&type="${JSON.stringify([15])}"`)
      .then((response) => {
        if (
          response?.data?.documents.length > 0 &&
          response?.data?.documents[0]
        ) {
          downloadFileFromUrl(response?.data?.documents[0]?.downloadLink);
        } else generateQuotePdf(quoteId);
      })
      .catch((error) => handleApiError(error));
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  useEffect(() => {
    if (isConfirm) {
      axios
        .delete(`/enquiry/${siteId}`)
        .then(() => {
          onRefreshData(true);
          setActionConfirmStatus(false);
        })
        .catch((error) => handleApiError(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  const onEdit = () => {
    history(`/site/view/${siteId}/quote-edit-${quoteId}`);
  };

  const openPopUpQuoteAction = (id) => {
    setDisplayDropdown(false);
    setStatusId(id);
    setQuotePopupVisible(true);
  };
  const closeQuoteActionPopup = () => {
    if (isQuotePopupVisible) {
      setQuotePopupVisible(!isQuotePopupVisible);
    }
  };

  return (
    <ActionButtons>
      <>
        {status === 1 && (
          <Image
            src={editIcon}
            alt={t("QUOTE_ACTION_TOOLTIP_EDIT")}
            title={t("QUOTE_ACTION_TOOLTIP_EDIT")}
            className="quote-listing__action-image-icon"
            onClick={onEdit}
          />
        )}
        {(status === 1 || status === 2 || status === 3) && (
          <Image
            src={cancelIcon}
            onClick={() => openPopUpQuoteAction("5")}
            alt={t("QUOTE_ACTION_TOOLTIP_CANCEL")}
            title={t("QUOTE_ACTION_TOOLTIP_CANCEL")}
            className="quote-listing__action-image-icon"
          />
        )}
        {quoteActions !== undefined && (
          <Image
            src={moreActionIcon}
            displayDropdown={displayDropdown}
            onClick={actionDropdownToggle}
            alt={t("QUOTE_ACTION_MORE_ACTION")}
            title={t("QUOTE_ACTION_MORE_ACTION")}
            className="quote-listing__action-image-icon"
          />
        )}
        {displayDropdown && quoteActions !== undefined && (
          <div className="quote-listing__dropdown-container">
            <ul className="quote-listing__dropdown-list">
              {quoteActions.map((item) => (
                <li
                  key={item.id}
                  className="quote-listing__list-item"
                  onClick={() => openPopUpQuoteAction(item.id)}
                >
                  <label className="document-label">{t(item.label)}</label>
                </li>
              ))}
            </ul>
          </div>
        )}
        {(status === 2 || status === 3 || status === 6 || status === 7) && (
          <Image
            src={downloadIcon}
            onClick={() => checkQuoteDocument(quoteId)}
            alt={t("QUOTE_ACTION_TOOLTIP_DOWNLOAD")}
            title={t("QUOTE_ACTION_TOOLTIP_DOWNLOAD")}
            className="quote-listing__action-image-icon"
          />
        )}
      </>
      {isConfirmVisible && (
        <WarningPopUp
          title={t(confirmationBoxTitle)}
          message={t(confirmationBoxContent)}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
      {isQuotePopupVisible && (
        <QuoteActionPopUp
          onClose={closeQuoteActionPopup}
          statusId={statusId}
          countryId={countryId}
          oldStatusId={status}
          onRefreshData={onRefreshData}
          quoteId={quoteId}
          setIsRefeshSiteData={setIsRefeshSiteData}
          siteId={siteId}
          pageType={pageType}
          jobsiteNeedKickoff={jobsiteNeedKickoff}
        />
      )}
    </ActionButtons>
  );
};

QuoteAction.propTypes = {
  t: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
};
export default withTranslation()(QuoteAction);
